import {
  ArrowDown24,
  DataViewAlt24,
  DocumentUnknown24,
  Download24,
} from "@carbon/icons-react";
import { Search32 } from "@carbon/icons-react";
import { Form, Loading } from "carbon-components-react";
import {
  Row,
  Column,
  TextInput,
  Button,
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
} from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Card from "../../components/Card/Card";
import TablePagination from "../../components/Pagination/Pagination";
import http from "../../http-common";
import { tree } from "d3";
import * as XLSX from "xlsx";
import useAuth from "../../hooks/useAuth";

const tableHeaders = [
  {
    header: "Nome",
    key: "name",
  },
  {
    header: "NUIT",
    key: "nuit",
  },

  {
    header: "Pontuação",
    key: "score",
  },
  {
    header: "Data de Pontuação",
    key: "evaluationDate",
  },
  {
    header: " ",
    key: "actions",
  },
];

const LinkList = ({ url1, url2, isOpen }) => (
  <ul style={{ display: "flex" }}>
    <li className="mr-1">
      <Link to={url1} title="Consultar Candidatura">
        <DataViewAlt24 />
      </Link>
    </li>
    {/* <li>
      <Link to={url2} title="Consultar Questionário">
        <DocumentUnknown24 />
      </Link>
    </li> */}
  </ul>
);

const getCellContent = (cell, id) => {
  if (cell.info.header === "actions") {
    return (
      <LinkList
        url1={"../candidature/" + id}
        url2={"../self-knowledge-questionnaire/" + id}
      />
    );
  }

  if (cell.info.header === "currentStatusCode") {
    return cell.value == 1 ? "Em aberto" : "Submetida";
  }

  if (cell.info.header === "score") {
    // If not scored, show "Não Pontuada", otherwise show the processed totalScore
    return cell.value.isScored ? cell.value.totalScore : "Não Pontuada";
  }

  return cell.value;
};

const JuryCandidaturesPage = () => {
  const [candidatures, setCandidatures] = useState([]);
  const [count, setCount] = useState(0);
  const [size, setSize] = useState(20);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { user } = useAuth();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const featchData = async () => {
    if (!user?.username) return;

    try {
      const response = await http.get(
        `/applications/eligible-for-jury/${user.username}/type/ADMINISTRATIVE_EVALUATION`
      );
      getApplicationData(response);
    } catch (error) {
      console.error("Error fetching jury candidatures:", error);
    }
  };

  const onPageChange = async ({ page, pageSize }) => {
    // Note: The new endpoint might not support pagination in the same way
    // This function is kept for compatibility but may need backend support
    setSize(pageSize);
    featchData();
  };

  const onSearch = async (data) => {
    // Note: The new endpoint might not support search in the same way
    // This function is kept for compatibility but may need backend support
    featchData();
  };

  const getApplicationData = (response) => {
    const data = response.data.map((c) => ({
      id: c.uuid,
      name: c.companyName,
      nuit: c.nuit,
      companyHeadquarters: c.companyHeadquarters,
      currentStatusCode: c.currentStatus,
      score: {
        isScored: c.isScored,
        totalScore:
          c.totalScore === null || c.totalScore === undefined
            ? "Não Pontuada"
            : typeof c.totalScore === "number"
            ? c.totalScore.toFixed(2)
            : c.totalScore,
      },
      evaluationDate: c.evaluationDate,
    }));
    // console.log(data);
    setCandidatures(data);
    setCount(data.length);
    setIsLoading(false);
  };

  useEffect(() => {
    featchData();
  }, [user]);

  return (
    <Card title="Candidaturas">
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />

      <DataTable
        rows={candidatures}
        headers={tableHeaders}
        isSortable
        useZebraStyles
      >
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            <TableToolbar aria-label="data table toolbar">
              <TableToolbarContent>
                <Form
                  className="data-table-search-form"
                  onSubmit={handleSubmit(onSearch)}
                >
                  <Row>
                    <Column sm={6} md={8} lg={8}>
                      <TextInput
                        id="name"
                        labelText=""
                        placeholder="Nome"
                        {...register("name")}
                      />
                    </Column>

                    {/* <Column sm={6} md={3} lg={3}>
                      <TextInput
                        id="phoneNumber"
                        labelText=""
                        placeholder="Telefone"
                        {...register("phoneNumber")}
                      />
                    </Column> */}
                  </Row>
                  <Button type="submit" renderIcon={Search32}>
                    Pesquisar
                  </Button>
                </Form>
              </TableToolbarContent>
            </TableToolbar>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {getCellContent(cell, row.id)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
      <TablePagination
        currentPageSize={size}
        onPageChange={onPageChange}
        totalItems={count}
      />
    </Card>
  );
};

export default JuryCandidaturesPage;
